import React, { useState } from 'react';
import { keyBoardAccessibilityAttributes } from '../../../utils/GeneralUtils';

const InfoBanner = ({
  message,
  dismissibleFn,
  additionalClasses = "",
  messageDirection = "flex-column",
  showInfoIcon = true
}) => {
  const [show, setShow] = useState(true);

  const handleDismiss = () => {
    setShow(false);
    dismissibleFn();
  };

  return (
    <>
      {show && (
        <div
          className={`d-flex align-items-start p-3 flex-gap-5 cui-border-radius-6 cui-info-subdued ${additionalClasses}`}
        >
          {showInfoIcon && (
            <span className="heading-lg">
              <i className="fa-regular fa-fw fa-circle-info" />
            </span>
          )}

          <div className={`d-flex ${messageDirection} gap-1`}>{message}</div>

          <span className="ml-auto heading-lg">
            <i
              className="fa-regular fa-fw fa-times pointer"
              onClick={handleDismiss}
              {...keyBoardAccessibilityAttributes}
            />
          </span>
        </div>
      )}
    </>
  );
};

export default InfoBanner;
